import { mileageRatedigitConfig } from 'src/app/common/commonvariables';
import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { filter, Subject, takeUntil } from 'rxjs';
import { MileageUOMEnum } from 'src/app/_models';

@Component({
    selector: 'formly-electric-charging-type',
    templateUrl: './formly-electric-charging-type.component.html',
    standalone: false
})
export class FormlyElectricChargingTypeComponent extends FieldType implements OnInit {
    private destroy$ = new Subject<void>();
    mileageRateFormat = '1.' + mileageRatedigitConfig + '-' + mileageRatedigitConfig;
    ngOnInit() {
        // Run immediately with whatever props.chargingType is at init time
        this.tryAutoSelect();

        // Re-run each time expressionProperties updates props.chargingType
        // (e.g. after GetResourceMileageDetails API resolves asynchronously)
        this.field.options?.fieldChanges?.pipe(
            filter((e: any) => e.field === this.field && e.property === 'props.chargingType'),
            takeUntil(this.destroy$)
        ).subscribe(() => {
            this.tryAutoSelect();
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    private tryAutoSelect() {
        const available = this.availableChargingTypes;
        if (!available.length) return;
        const current = this.formControl.value;
        // Only auto-select if there's no value yet, or the current value is no longer in available types
        if (!current || !available.includes(current)) {
            const preferred = this.model?.chargingType && available.includes(this.model.chargingType)
                ? this.model.chargingType
                : available[0];
            this.formControl.setValue(preferred);
        }
    }


    get allowedChargingType(): number {
        return this.field.props?.chargingType ?? 3;
    }

    get availableChargingTypes(): number[] {
        const ct = this.allowedChargingType;
        const result: number[] = [];
        if (ct === 1 || ct === 3) result.push(1);
        if (ct === 2 || ct === 3) result.push(2);
        return result;
    }

    get activationRequestStatus(): number {
        return this.field.props?.activationRequestStatus ?? 0;
    }

    get mileageRateInfo(): any[] {
        return this.field.props?.mileageRateInfo ?? [];
    }
    get mileageUOM(): string {
        return this.field.props?.mileageUOM === MileageUOMEnum.Kilometre
            ? 'km'
            : 'm';
    }

    getRateForType(chargingType: number): number {
        const info = this.mileageRateInfo.find((r: any) => r.chargingType === chargingType);
        return info?.mileageRate ?? 0;
    }

    selectChargingType(ct: number) {
        this.formControl.setValue(ct);
        if (this.field.props?.change) {
            this.field.props.change(this.field, ct);
        }
    }

    onDisabledChargingTypeClick(ct: number) {
        if (!this.availableChargingTypes.includes(ct) && this.field.props?.onDisabledClick) {
            this.field.props.onDisabledClick(ct);
        }
    }
}
